import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type DrawerState = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
  setOpen: (value: boolean) => void;
};

// ponytail: persisted so the desktop sidebar remembers expanded/collapsed across reloads.
// Mobile drawer resets on entry (see Header) so it never auto-opens from a stale value.
export const useDrawerStore = create<DrawerState>()(
  persist(
    (set) => ({
      isOpen: false,
      open: () => set({ isOpen: true }),
      close: () => set({ isOpen: false }),
      toggle: () => set((s) => ({ isOpen: !s.isOpen })),
      setOpen: (value) => set({ isOpen: value }),
    }),
    { name: 'vh-sidebar', partialize: (s) => ({ isOpen: s.isOpen }) },
  ),
);
